import { ActionType } from "./types";
import * as actionTypes from "../action";
import { addDays, format } from "date-fns";
import { vi } from "date-fns/locale";

const initialState: any = {
  currentTabIndex: 0,
  currentReports: undefined,
  startDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
  endDate: new Date(),
  currentProjectName: "All",
  dateRange: {
    selection1: {
      startDate: addDays(new Date(), -7),
      endDate: new Date(),
      key: 'selection1'
    },
    selection2: {
      startDate: addDays(new Date(), -14),
      endDate: addDays(new Date(), -8),
      key: 'selection2'
    }
}
};

const reportReducer = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case actionTypes.SET_START_DATE: {
      return {
        ...state,
        startDate: action.payload,
      };
    }
    case actionTypes.SET_END_DATE: {
      return {
        ...state,
        endDate: action.payload,
      };
    }
    case actionTypes.SET_PROJECT_NAME: {
      return {
        ...state,
        currentProjectName: action.payload,
      };
    }
    case actionTypes.SET_DATE_RANGE : {
      return {
        ...state,
        dateRange: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default reportReducer;
